import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-gallery-slider', observe: true })
export class GallerySliderComponent {
	private instance: any;

	constructor(private element: HTMLElement, isCalledFromExternal = false, index = 0) {
		const isInModal = this.element.getAttribute('data-in-modal') === 'true';

		if (isInModal) {
			if(isCalledFromExternal){
				this.init(true, index);
				this.slideChange();
			}
		} else {
			this.init(false, index);
		}
	}

	init(isInModal: boolean, index: number) {
		const wrapper = this.element.querySelector('.js-gallery-slider__wrapper') as HTMLElement;
		const pagination = this.element.querySelector('.js-gallery-slider__pagination') as HTMLElement;
		const navigation = this.element.querySelector('.js-gallery-slider__navigation') as HTMLElement;

		if (wrapper) {
			let navigationInstance = null;
			if(navigation){
				const paginationNextEl = navigation.querySelector('.js-gallery-slider__navigation__next') as HTMLElement;
				const paginationPrevEl = navigation.querySelector('.js-gallery-slider__navigation__prev') as HTMLElement;

				navigationInstance = new Swiper(navigation, {
					slidesPerView: isInModal ? 8 : 5,
					centerInsufficientSlides: false,
					spaceBetween: 10,
					autoHeight: false,
					initialSlide: index,
					//freeMode: true,
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
					navigation: {
						nextEl: paginationNextEl,
						prevEl: paginationPrevEl
					},
					breakpoints: {
						320: {
							slidesPerView: 5,
							spaceBetween: 10
						},
						768: {
							slidesPerView: 6,
							spaceBetween: 15
						},
						1024: {
							slidesPerView: isInModal ? 7 : 5,
							spaceBetween: isInModal ? 20 : 10
						},
						1230: {
							slidesPerView: isInModal ? 8 : 5,
							spaceBetween: isInModal ? 20 : 10
						}
					}
				});
			}
			

			this.instance = new Swiper(wrapper, {
				initialSlide: index,
				navigation: {
					nextEl: this.element.querySelector('.swiper-button-next') as HTMLElement,
					prevEl: this.element.querySelector('.swiper-button-prev') as HTMLElement
				},
				keyboard: true,
				autoHeight: true,
				on: {
					slideChange: this.slideChange
				},
				thumbs: navigationInstance != null ? {
					swiper: navigationInstance
				} : {}
			});

			document.addEventListener('lazyloaded', () => this.instance.update());
			
			if(screen.orientation && screen.orientation != undefined){
				screen.orientation.addEventListener('change',() => this.instance.update());
			}
			else{
				window.addEventListener('orientationchange', () => this.instance.update());
			}
		}
	}

	slideChange = () => {
		if (this.instance && this.instance.slides) {
			const previousItem = this.instance.slides[this.instance.previousIndex];
			const activeItem = this.instance.slides[this.instance.activeIndex];

			if (previousItem || activeItem) {
				this.startIFrame(activeItem);
				this.stopIFrame(previousItem);
			}
		}
	};

	destroy() {
		this.stopAllIFrames(this.element);
		this.instance.destroy();
	}

	private stopIFrame(el: HTMLElement) {
		const iframe = this.findIFrame(el);
		if (iframe) {
			iframe.setAttribute('src', '');
		}
	}

	private stopAllIFrames(el: HTMLElement) {
		this.findAllIFrames(el).forEach(e => this.stopIFrame(e.parentElement));
	}

	private startIFrame(el: HTMLElement) {
		const iframe = this.findIFrame(el);
		if (iframe) {
			iframe.setAttribute('src', iframe.getAttribute('data-src'));
		}
	}

	private findIFrame(el: HTMLElement): HTMLElement {
		if (el) {
			return el.querySelector('iframe');
		}
	}

	private findAllIFrames(el: HTMLElement): HTMLElement[] {
		if (el) {
			return Array.from(el.querySelectorAll('iframe')) as HTMLElement[];
		}
	}
}
